import {
  SET_MEMBER_DATA,
  SET_MEMBER_ENROLLMENT_RANK_LIST,
  SET_MEMBER_HIGHEST_RANK_LIST,
  SET_MEMBER_LIST_DATA,
  SET_MEMBER_MIGRATION_LIST_DATA,
  SET_MEMBER_RANK_LIST_DATA,
  SET_MEMBER_SALES_HISTORY_LIST_DATA,
  SET_MEMBER_TABS_DATA,
  SET_MEMBER_TRANSACTION_LIST_DATA,
  SET_MEMBER_TREE,
  SET_MEMBERS_MULTI_FUNCTIONAL_TREE,
  SET_MEMBERS_ON_BEHALF_TOKEN,
  SET_MEMBERS_STATUS_LIST,
  SET_MEMBERS_TREE,
  UNSET_MEMBER_DATA,
  SET_MEMBER_NEXT_PLACEMENT_POSITION,
  SET_MEMBER_COUNCIL_RANK_LIST,
  SET_MEMBER_PERFORMANCE_DATA,
  SET_MEMBER_SPONSOR_LISTING_DATA,
  UNSET_MEMBER_SPONSOR_LISTING_DATA,
  SET_MEMBER_SPONSOR_LISTING_FILTERS_DATA,
} from 'src/store/types'
import Vue from 'vue'

export default {
  [SET_MEMBER_LIST_DATA](state, payload) {
    Vue.set(state.memberList, 'list', payload.list)
  },
  [SET_MEMBER_TREE](state, payload) {
    Vue.set(state, 'memberTree', payload.memberTree)
  },
  [SET_MEMBER_TABS_DATA](state, payload) {
    Vue.set(state.tabsData, 'data', payload.list)
  },
  [SET_MEMBERS_TREE](state, payload) {
    Vue.set(state, 'memberTree', payload.memberTree)
  },
  [SET_MEMBER_DATA](state, payload) {
    Vue.set(state.memberData, 'data', payload.data)
  },
  [UNSET_MEMBER_DATA](state) {
    state.memberData = {
      data: {},
    }
  },
  [SET_MEMBERS_MULTI_FUNCTIONAL_TREE](state, payload) {
    Vue.set(state.memberMultiFunctionTreeData, 'list', payload.list)
  },
  [SET_MEMBER_RANK_LIST_DATA](state, payload) {
    Vue.set(state.memberRankList, 'list', payload.data)
  },
  [SET_MEMBER_HIGHEST_RANK_LIST](state, payload) {
    Vue.set(state.highestRankList, 'list', payload.list)
  },
  [SET_MEMBER_ENROLLMENT_RANK_LIST](state, payload) {
    Vue.set(state.enrollmentRankList, 'list', payload.list)
  },
  [SET_MEMBER_MIGRATION_LIST_DATA](state, payload) {
    Vue.set(state.memberMigrationList, 'list', payload.data)
  },
  [SET_MEMBERS_STATUS_LIST](state, payload) {
    Vue.set(state.memberStatusList, 'list', payload.data)
  },
  [SET_MEMBER_TRANSACTION_LIST_DATA](state, payload) {
    Vue.set(state.memberWalletTransactionList, 'list', payload.data)
  },
  [SET_MEMBER_SALES_HISTORY_LIST_DATA](state, payload) {
    Vue.set(state.memberSalesHistoryList, 'list', payload.list)
  },
  [SET_MEMBERS_ON_BEHALF_TOKEN](state, payload) {
    Vue.set(state.memberOnBehalfToken, 'data', payload.data)
  },
  [SET_MEMBER_NEXT_PLACEMENT_POSITION](state, payload) {
    Vue.set(state.memberNextPlacement, 'data', payload.data)
  },
  [SET_MEMBER_COUNCIL_RANK_LIST](state, payload) {
    Vue.set(state.councilRankList, 'list', payload.list)
  },
  [SET_MEMBER_PERFORMANCE_DATA](state, payload) {
    Vue.set(state.downlinePerformanceList, 'list', payload.list)
  },
  [SET_MEMBER_SPONSOR_LISTING_DATA](state, payload) {
    Vue.set(state.memberSponsorDownlineListing, 'list', payload.list)
  },
  [UNSET_MEMBER_SPONSOR_LISTING_DATA](state) {
    Vue.set(state.memberSponsorDownlineListing, 'list', {
      data: [],
      total: 0,
      details: {},
      dynamic_filters_total: [],
    })
  },
  [SET_MEMBER_SPONSOR_LISTING_FILTERS_DATA](state, payload) {
    Vue.set(state.memberSponsorDownlineListingFilters, 'list', payload.list)
  },
}
